export default {

    auth: false,
	
    user: {},

    permissions: {},

    operators: [],
	
	rights: 
	{
		RIGHT_CREATE:1,
		RIGHT_READ:2,
		RIGHT_UPDATE:4,
		RIGHT_DELETE:8,
		RIGHT_READALL:16,
	},

    loading: {
        active: false,
        message: null
    },
    connectionsOptions: {
        filters:{}
    },
    expectsOptions: {
        filters:{}
    },
    malfunctionsOptions: {
        filters:{}
    },
    maintenanceOptions: {
        filters:{},
        sortBy:['start'],
        sortDesc:[true],
    },
    actionsOptions: {
        filters:{}
    },
}
